import { isRequired } from '../../../utils/validation';

export const initialValues = {
  type: '',
  agenId: '',
  startDate: '',
  endDate: ''
};

export const fieldsProps = {
  type: {
    name: 'type',
    data: [
      { value: 'Sementara', label: 'Sementara' },
      { value: 'Permanen', label: 'Permanen' },
    ],
    placeholder: '',
    label: 'Jenis Penggantian Agen',
    info: 'Setelah tanggal penggantian berakhir, otomatis beralih ke agen sebelumnya.'
  },
  agent: {
    name: 'agenId',
    placeholder: '',
    label: 'Pilih Agen Pengganti',
  },
  dates: {
    required: true,
    inputFormat: 'DD MMMM YYYY',
    locale: 'id',
  },
  startDate: {
    name: 'startDate',
    required: true,
    valueFormat: 'DD MMMM YYYY',
    placeholder: 'Pilih Tanggal',
    label: 'Tanggal Awal Penggantian',
    info: 'Tanggal awal penggantian agen'
  },
  endDate: {
    name: 'endDate',
    required: true,
    valueFormat: 'DD MMMM YYYY',
    placeholder: 'Pilih Tanggal',
    label: 'Tanggal Akhir Penggantian',
    info: 'Tanggal berakhirnya penggantian agen'
  },
};

export const validate = (values = initialValues) => {
  const { type, agenId } = values;
  const rules = {
    type: isRequired(type, 'Jenis Penggantian Agen harus dipilih'),
    agenId: isRequired(agenId, 'Agen Pengganti harus dipilih'),
    startDate: isRequired(values.startDate, 'Tanggal Awal Penggantian harus diisi'),
    endDate: type === 'Sementara' ?
      isRequired(values.endDate, 'Tanggal Akhir Penggantian harus diisi') ||
      (values.startDate && values.endDate && values.startDate > values.endDate &&
        'Tanggal Akhir Penggantian harus lebih besar dari Tanggal Awal Penggantian')
      : null,
  };

  return rules;
};
